import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { BulkCreateCapitalNeedMutation, CapitalNeedInput } from '#/graphql/types';
import { bulkCreateCapitalNeed } from '#/graphql/mutations';
import { get } from 'lodash';

const q = gql(bulkCreateCapitalNeed);

const useBulkCreateCapitalNeed = () => {
  const [mutation, result] = useMutation<BulkCreateCapitalNeedMutation>(q);
  const bulkCreateCapitalNeed = useCallback(
    async (data: CapitalNeedInput[]) => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.bulkCreateCapitalNeed', undefined);

      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Bulk create failed';
        throw new Error(errorMessage);
      }

      return result;
    },
    [mutation],
  );

  return { bulkCreateCapitalNeed, result };
};

export default useBulkCreateCapitalNeed;
